import { render, staticRenderFns } from "./FinanceBalancesUserBalances.vue?vue&type=template&id=bd0d3ac6&"
import script from "./FinanceBalancesUserBalances.vue?vue&type=script&lang=js&"
export * from "./FinanceBalancesUserBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports